module.exports = __webpack_public_path__ + "img/infografia.7c92f80e.jpg";